import React from 'react';
import * as styles from './separator.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default () => ___EmotionJSX("span", {
  css: styles.separator
});